import { Outlet } from "react-router-dom";
import Navbar from "../components/navigation/Navbar";
import ScrollToHash from "../routes/ScrollToHash";
import "../styles/layouts.css";

// AppLayout is the shared page "wrapper" for most pages on the site.
// It keeps the same top navigation and page structure while the main content changes.
// Examples of pages that use this layout:
// - Home (`/`)
// - Auth (`/auth`)
// - Admin (`/admin`)
function AppLayout() {
  return (
    <div className="app-shell">
      {/* Navbar:
          The top menu bar that stays visible while you move around the site.
          Example: you can click "Contact Us" from Home or from the Auth page. */}
      <Navbar />

      {/* ScrollToHash:
          Helps “jump to section” links on the Home page work nicely.
          Example: if you click “Partners”, the URL may become `/#partners` and the page
          scrolls down to the Partners section automatically. */}
      <ScrollToHash />

      {/* Main content area:
          This is where the current page will show up. */}
      <main className="app-main">
        {/* Outlet:
            Think of this as an empty slot where the current page is placed.
            Examples:
            - URL `/` shows the Home page here
            - URL `/auth` shows the Auth page here
            - URL `/admin` shows the Admin page here */}
        <Outlet />
      </main>
    </div>
  );
}

export default AppLayout;

